module.exports = __webpack_public_path__ + "img/Animasi.f3e93ef8.jpg";